import { useQuery } from '@tanstack/react-query';
import { getTerminal } from './adminTerminalService';

/**
 * Get terminal by ID
 * @param {string} airportId - The airport ID.
 * @param {string} terminalId - The terminal ID.
 * @param {object} [params] The params
 * @param {object} [params.options] The query options.
 * @returns {import('@tanstack/react-query').UseQueryResult<Terminal, Error>} The query result.
 */
export const useGetTerminal = (airportId, terminalId, params = {}) => {
  const { options = {} } = params;
  const defaultEnabled = !!airportId && !!terminalId;

  return useQuery({
    queryKey: ['get-terminal', airportId, terminalId],
    queryFn: () => getTerminal(airportId, terminalId),
    enabled: defaultEnabled,
    ...options,
  });
};
